import { ForeignLocalDataDecision, type ForeignLocalDataReason } from '@wiztime/sync/config';
import { create } from 'zustand';

export interface ForeignDataQuestion {
  /** Records on this device that belong to another space. */
  readonly localRecords: number;
  /** Another space was synced here before, or the origin of the records is unknown (backup, old sync). */
  readonly reason: ForeignLocalDataReason;
}

interface PromptState {
  readonly question: ForeignDataQuestion | null;
  /** Show the question and resolve with the answer; a question still open is answered with "cancel". */
  ask(question: ForeignDataQuestion): Promise<ForeignLocalDataDecision>;
  answer(decision: ForeignLocalDataDecision): void;
}

let resolveOpen: ((decision: ForeignLocalDataDecision) => void) | null = null;

/** The question "this device holds data of another account" that the sync manager asks while activating sync. */
export const useForeignDataPrompt = create<PromptState>((set) => ({
  question: null,
  ask(question) {
    resolveOpen?.(ForeignLocalDataDecision.Cancel);
    return new Promise<ForeignLocalDataDecision>((resolve) => {
      resolveOpen = resolve;
      set({ question });
    });
  },
  answer(decision) {
    const resolve = resolveOpen;
    resolveOpen = null;
    set({ question: null });
    resolve?.(decision);
  },
}));

export function askForeignLocalData(question: ForeignDataQuestion): Promise<ForeignLocalDataDecision> {
  return useForeignDataPrompt.getState().ask(question);
}
